export default "__VITE_ASSET__c6ae906c__"